<div odxLayout="flex vertical-center" class="container scroll">
  <odx-header id="header" odxLayout="12">
    <odx-header-title>
      <div odxLayout="flex vertical-center">
        <a href="#" odxLayout="flex vertical-center" data-testid="navintaLogo">
          <img src="assets/navinta_logo.svg" alt="navinta logo" />
        </a>
        <a href="#"> Navinta</a>
      </div>
    </odx-header-title>
  </odx-header>
  <div class="odx-display-md" i18n="@@externalUser.header1">Willkommen bei Navinta!</div>

  <h5 class="odx-heading-5" i18n="@@externalUser.header2">
    Ihr Konto wurde noch nicht freigeschaltet. <br />
    Bitte kontaktieren Sie Ihren Admin, um Zugriff auf Navinta zu erhalten.
  </h5>

  <button odxButton variant="primary" (click)="logOut()">
    <span i18n="@@externalUser.button.backToLogin">Zurück zum Login</span>
  </button>

  <footer odxLayout="flex">
    <odx-logo size="medium" variant="default"></odx-logo>
    <p class="odx-heading-6">Technik für das Leben</p>
  </footer>
</div>
